import React, { useEffect, useState } from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'
import { enNZ } from 'date-fns/locale'
import {
  DATE_PLACEHOLDER,
  formatDdMmYyyyFromDate,
  parseDdMmYyyy,
} from '../data/date_format.js'
import 'react-datepicker/dist/react-datepicker.css'

registerLocale('en-NZ', enNZ)

export default function HireDateField({ id, value, onChange, ariaLabel, minDate }) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return (
      <input
        type="text"
        id={id}
        className="hire_date_input"
        placeholder={DATE_PLACEHOLDER}
        autoComplete="off"
        readOnly
        aria-label={ariaLabel}
      />
    )
  }

  return (
    <DatePicker
      id={id}
      selected={parseDdMmYyyy(value)}
      onChange={(date) => onChange(date ? formatDdMmYyyyFromDate(date) : '')}
      dateFormat="dd/MM/yyyy"
      locale="en-NZ"
      placeholderText={DATE_PLACEHOLDER}
      autoComplete="off"
      showPopperArrow={false}
      className="hire_date_input"
      calendarClassName="hire_date_calendar"
      popperClassName="hire_date_popper"
      aria-label={ariaLabel}
      minDate={minDate || undefined}
    />
  )
}
